import { parsePhoneNumberFromString as parsePhoneNumber } from 'libphonenumber-js/max';

/**
 * Format the phone number to a US or BR format
 * @category Formatters
 * @category Phone
 */
export function mobilePhoneMask(initialValue = '') {
  if (!initialValue) {
    return '';
  }
  const countryCodeUS = '+1 ';
  const countryCodeBR = '+55 ';
  const parsedPhoneNumber = parsePhoneNumber(initialValue);

  // first the lib check the number to apply the mask
  if (
    parsedPhoneNumber &&
    parsedPhoneNumber.isValid() &&
    (parsedPhoneNumber.country === 'US' || parsedPhoneNumber.country === 'BR')
  ) {
    return `${
      parsedPhoneNumber.country === 'US' ? countryCodeUS : countryCodeBR
    } ${parsedPhoneNumber.formatNational()}`;
  }

  // when it is a possible number but is not valid
  if (
    parsedPhoneNumber &&
    parsedPhoneNumber.isPossible() &&
    !parsedPhoneNumber.isValid()
  ) {
    return parsedPhoneNumber.formatInternational();
  }

  // otherwise we continue the flow
  const value = initialValue
    .replace(/\+55|\+1/, '')
    .replace(/[^\d]/g, '')
    .trim();

  let phoneNumber = parsePhoneNumber(`${countryCodeUS}${value}`, 'US');
  if (phoneNumber && phoneNumber.isValid()) {
    return `${countryCodeUS}${phoneNumber.formatNational()}`;
  }
  phoneNumber = parsePhoneNumber(`${countryCodeBR}${value}`, 'BR');
  if (phoneNumber && phoneNumber.isValid()) {
    return `${countryCodeBR}${phoneNumber.formatNational()}`;
  }

  return value.slice(0, 11);
}
